export default {
  state: {
    currencyList: [{ //币种
      value: 'USD',
      label: '美元'
    }, {
      value: 'CNY',
      label: '人民币'
    }],
    bankAccountType: [{
      value: 1,
      label: 'savings accounts'
    }, {
      value: 2,
      label: 'basic checking accounts'
    }, {
      value: 3,
      label: 'interest-bearing checking accounts'
    }, {
      value: 4,
      label: 'money market deposit accounts'
    }, {
      value: 5,
      label: 'certificates of deposit'
    }],
    cuntryList: [{ //国家
      value: 'US',
      label: '美国'
    }, {
      value: 'CHN',
      label: '中国'
    }],
    holderTypeList: [{
      value: 'individual',
      label: '个人账号'
    }, {
      value: 'company',
      label: '企业账号'
    }],
    // {
    //   value: 1,
    //   label: '付费商品'
    // }, {
    //   value: 2,
    //   label: '免费商品'
    // },
    couponType: [{
      value: '',
      label: '全部'
    }, {
      value: 3,
      label: '固定金额',
      icon: 'el-iconfont iconfont-coupon-fixed'
    }, {
      value: 4,
      label: '套餐/秒杀',
      icon: 'el-iconfont iconfont-coupon-clock',
      onlyAll: true //套餐秒杀只能一次验券全部
    }],
    couponState: [{
      value: '',
      label: '全部'
    }, {
      value: 1,
      label: '上架'
    }, {
      value: 0,
      label: '下架'
    }],
    refundsRule: [{
      value: 'anyTime',
      label: '随时可退'
    }, {
      value: 'overdue',
      label: '过期可退'
    }, {
      value: 'notRefundable',
      label: '不可退'
    }],
    // pending 邀请中 normal 启动中 forbidden 未启动 delete 删除'
    assistantStatus: [{
      value: 'pending',
      label: '邀请中'
    }, { // pendingExpired
      value: 'pendingExpired',
      label: '邀请已过期'
    }, {
      value: 'normal',
      label: '启动中'
    }, {
      value: 'forbidden',
      label: '未启动'
    }, {
      value: 'delete',
      label: '删除'
    }],
    dataSearchType: [{
      label: '访客数',
      value: 'uv'
    }, {
      label: '浏览量',
      value: 'pv'
    }, {
      label: '交易数',
      value: 'transNum'
    }, {
      label: '交易人数',
      value: 'transUserNum'
    }, {
      label: '成交人数',
      value: 'turnoverUserNum'
    }, {
      label: '成交数',
      value: 'turnoverNum'
    }, {
      label: '交易额',
      value: 'transAmount'
    }],
    noticeType: [{
        value: '1',
        label: '通知助手'
      },
      //  {
      //    value: '2',
      //    label: '门店动态'
      //  },
      {
        value: '3',
        label: '审核消息'
      }
    ]
  },
  mutations: {},
  getters: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/selector.js